export default function (Vue)　{

    // POST 傳遞參數序列化( 添加 request 攔截器 )
    // 在發送请求之前做某件事
    Vue.$http.interceptors.request.use( config => {

        // token
        if (localStorage.token) {
            config.headers.Authorization = localStorage.token
        }

        if (Vue.$store.state.user.language) {
            // console.log( Vue.$store.state.user.language )
            config.headers['X-localization'] = Vue.$store.state.user.language
        }

        return config
    }, error => {
        // console.log( '錯誤的參數傳遞', 'fail' )
        return Promise.reject(error)
    })

    //返回狀態判断 ( 添加 response 攔截器)
    Vue.$http.interceptors.response.use( response => {
        // 如果 header 中存在 token，那么触发 refreshToken 方法，替换本地的 token
        // Vue.$store.commit('user/refreshToken', response)

        return response

    }, error => {

        // console.log(error)
        if (error.response)
        {
            let _page = '';
            switch (error.response.status)
            {
                // 400 Bad Request 就彈出錯誤訊息
                // 因為有可能網址亂打超出現有數量的 project 或 cropperiod 等，除彈出訊息，順便將頁面導向 404
                case 400:
                    Vue.$toastr.e(error.response.message, error.response.status)
                    Vue.$router.push({ name: 'Page404' }) // 導向 404
                    break;

                // 401 Unauthorized 表示 token 驗證失敗、過期
                // 非 login page 就直接跳轉到登入頁面，重新登入取得新 token
                case 401:
                    // Vue.$store.commit('user/cleanData'); // 清除資料
                    // localStorage.removeItem('token');    // 清空 token

                    _page = process.env.BASE_URL + 'login';
                    if ( location.pathname == process.env.BASE_URL + 'reports' )
                    {
                        // 如果在 report 頁面的 401 就不導回 login，只清除 token 停留在原本頁面
                    }
                    else if ( location.pathname !== _page ) {
                        Vue.$router.push({ name: 'Login' }) // 導向 Login
                    }
                    break;

                // 403 Forbidden 無權限
                case 403:
                    // 非 login page 就轉到 403 頁面
                    _page = process.env.BASE_URL + 'login';
                    if ( location.pathname !== _page ) {
                        Vue.$router.push({ name: 'Page403' }) // 導向 403
                    }
                    else
                    {
                        Vue.$store.commit('user/cleanData'); // 清除資料
                        localStorage.removeItem('token');    // 清空 token
                    }

                    break;

                // 404 Not Found 無此頁面
                case 404:
                    // Vue.$router.push({ name: 'Page404' }) // 導向 404
                    break;

                // 500 Internal Server Error 伺服器錯誤
                case 500:
                    Vue.$router.push({ name: 'Page500' })
                    break;

                default:
                    // Vue.$toastr.e(error.response.message)
                    // console.log(error.response)
                    break;
            }
            // 返回 response 的錯誤資訊
            return Promise.reject(error.response)
        }

        if ( error.message == 'Network Error')
        {
            Vue.$router.push({ name: 'Page500' })
            return Promise.reject(error.message)
        }

        // 直接返回 error 的錯誤資訊
        return Promise.reject(error)
    })
}
